import { PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { FC } from "react";

import Translated from "../infrastructure/components/Translated";
import { getStoreLink } from "../infrastructure/device-util";
import { useTranslate } from "../infrastructure/hooks/useTranslate";
import styles from "./PasswordLogin.module.less";

const PasswordLogin: FC = () => {
  const translate = useTranslate();

  return (
    <div className={styles.body}>
      <Heading level={2} size={"large"} className={styles.header}>
        <Translated textKey={"login.discontinued.header"} />
      </Heading>
      <p className={styles.subheader}>
        {translate("login.discontinued.subheader")}
      </p>
      <PrimaryButton
        className={styles.fullWidthButton}
        as={"a"}
        size={"large"}
        href={getStoreLink()}
      >
        <Translated textKey={"login.update_app"} />
      </PrimaryButton>
    </div>
  );
};

export default PasswordLogin;
